import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Helmet } from "react-helmet-async";

const FALLBACK_ORIGIN = "https://travele.co.id";

export const Breadcrumbs = ({ items, maxWidth = "max-w-7xl" }) => {
  const origin = typeof window !== "undefined" ? window.location.origin : FALLBACK_ORIGIN;
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      ...(it.path ? { item: `${origin}${it.path}` } : {}),
    })),
  };

  return (
    <nav className="border-b border-border bg-card" aria-label="Breadcrumb" data-testid="breadcrumb">
      <div className={`mx-auto flex ${maxWidth} items-center gap-1 px-4 py-3 text-xs text-muted-foreground sm:px-6`}>
        {items.map((it, i) => (
          <span key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3 w-3" />}
            {it.path ? (
              <Link to={it.path} className="hover:text-primary">{it.name}</Link>
            ) : (
              <span className="truncate text-foreground">{it.name}</span>
            )}
          </span>
        ))}
      </div>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
    </nav>
  );
};
